import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "state/store";

interface PartnerGameState {
  embedUrl: string | null;
}

const initialState: PartnerGameState = {
  embedUrl: null,
};

const adContestSlice = createSlice({
  name: "partnerGame",
  initialState,
  reducers: {
    setEmbedUrl: (state, action) => {
      state.embedUrl = action.payload;
    },
    clearEmbedUrl: (state) => {
      state.embedUrl = null;
    },
  },
});

export const { setEmbedUrl, clearEmbedUrl } = adContestSlice.actions;

export const getPartnerGameState = (state: RootState) => state.partnerGame;

export default adContestSlice.reducer;
